import { getCreditConfigCount, getCreditConfigs } from "@graphql2/graphql_op";
import { AddCreditConfigProps, GetCreditConfigCountProps, GetCreditConfigsProps, UpdateCreditConfigProps, withAddCreditConfig, withGetCreditConfigCount, withGetCreditConfigs, withUpdateCreditConfig } from "@graphql2/types";
import { cleanCache } from "@utils/cleanCacheHoc";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { compose } from "redux";
import { AddCreditTypePage } from "./addCreditTypePage";

interface AddCreditTypePageRouteProps extends RouteComponentProps<{ id: string|undefined; }> { }

const getCreditConfigsQuery = withGetCreditConfigs({
    name: "creditConfigs"
});

const getCreditConfigCountQuery = withGetCreditConfigCount({
    name: "creditConfigCount"
});

const addCreditConfigMutation = withAddCreditConfig({
    name: "addCreditConfig",
    options: {
        refetchQueries: () => ["getCreditConfigs", "getCreditConfigCount"],
        awaitRefetchQueries: true,
        update: cleanCache([getCreditConfigs, getCreditConfigCount])
    }
});

const updateCreditConfigMutation = withUpdateCreditConfig({
    name: "updateCreditConfig",
    options: {
        refetchQueries: () => ["getCreditConfigs"],
        awaitRefetchQueries: true,
        update: cleanCache([getCreditConfigs])
    }
});

export const AddCreditTypePageContainer = compose<React.ComponentClass<AddCreditTypePageProps>>(
    withRouter,
    getCreditConfigCountQuery,
    getCreditConfigsQuery,
    addCreditConfigMutation,
    updateCreditConfigMutation
)(AddCreditTypePage);

export type AddCreditTypePageProps =
    AddCreditTypePageRouteProps &
    GetCreditConfigCountProps<{}, "creditConfigCount"> &
    GetCreditConfigsProps<{}, "creditConfigs"> &
    AddCreditConfigProps<{}, "addCreditConfig"> &
    UpdateCreditConfigProps<{}, "updateCreditConfig">;
